export const EXPORT_STATUS = {
  SUCCESS: "SUCCESS",
  IN_PROGRESS: "IN_PROGRESS",
  FAILED: "ERROR",
};

export const EXPORT_FILE_TYPE = {
  PDF: "PDF",
  ZIP: "ZIP",
};

export class FolderExportCheck {
  constructor({ lastZipExport = null, pdf = {}, zip = {} } = {}) {
    this.lastZipExport = lastZipExport ? new FolderExport(lastZipExport) : null;
    this.pdf = new ExportCheckDetail(pdf);
    this.zip = new ExportCheckDetail(zip);
  }
}

export class ExportCheckDetail {
  constructor({ allowed = false, disallowedReason = "" } = {}) {
    this.allowed = allowed;
    this.disallowedReason = disallowedReason;
  }
}

export class FolderExport {
  constructor({
    id = NaN,
    exportFile = "",
    exportFileType = EXPORT_FILE_TYPE.PDF,
    status = EXPORT_STATUS.IN_PROGRESS,
    dateCreated = null,
    dateUpdated = null,
  }) {
    this.id = id;
    this.exportFile = exportFile;
    this.exportFileType = exportFileType;
    this.status = status;
    this.dateCreated = dateCreated ? new Date(dateCreated) : null;
    this.dateUpdated = dateUpdated ? new Date(dateUpdated) : null;
  }
}
